import React, { useEffect, useMemo, useRef, useState } from 'react';
import ViewDealsButton from '@/components/UI/ViewDealsButton';
import type { RefObject } from 'react';

enum WordState {
  forward,
  backward,
}

export function useOnScreen(ref?: RefObject<Element>) {
  const [isOnScreen, setIsOnScreen] = useState(false);
  const observerRef = useRef<null | IntersectionObserver>(null);

  useEffect(() => {
    observerRef.current = new IntersectionObserver(([entry]) =>
      setIsOnScreen(entry.isIntersecting)
    );
  }, []);

  useEffect(() => {
    ref?.current && observerRef?.current?.observe(ref.current);
    return () => {
      observerRef?.current?.disconnect();
    };
  }, [ref]);

  return isOnScreen;
}

const TypingEffect = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [text, setText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [charPosition, setCharPosition] = useState(0);
  const [wordState, setWordState] = useState(WordState.forward);
  const messages = useMemo(() => ['As a toy ', 'On drinks packaging '], []);
  const isVisible = useOnScreen(ref);

  useEffect(() => {
    if (!isVisible) return;
    const timer = setTimeout(() => {
      if (currentIndex < messages.length) {
        const currentMessage = messages[currentIndex];
        setText((prevText) =>
          wordState === WordState.forward
            ? prevText + currentMessage.charAt(prevText.length)
            : currentMessage.slice(0, -1 + charPosition)
        );

        setCharPosition((prevPos) =>
          wordState === WordState.forward ? (prevPos += 1) : (prevPos -= 1)
        );

        if (
          text.length === currentMessage.length &&
          wordState === WordState.forward
        ) {
          setWordState(WordState.backward);
        }

        if (text.length === 0 && wordState === WordState.backward) {
          setWordState(WordState.forward);
          setText('');
          setCurrentIndex((index) => (index += 1));
        }
      } else {
        setCurrentIndex(0);
      }
    }, 90);

    return () => {
      clearTimeout(timer);
    };
  }, [text, currentIndex, messages, wordState, charPosition, isVisible]);

  return (
    <div className="mx-4">
      <div
        ref={ref}
        className="mx-auto mb-6 flex w-full max-w-[1120px] grow flex-col items-center justify-center rounded-3xl bg-[url('/img/FooterCTAMobile.png')] bg-cover bg-center bg-no-repeat md:bg-[url('/img/footerCTA.png')]"
      >
        <div className="flex w-full grow flex-col items-center justify-center py-32 md:py-20">
          <div className="flex flex-col items-center justify-center space-y-2 p-2">
            <h3 className="mb-4 font-gt-haptik text-heading-4-mobile text-white md:text-heading-3">
              Imagine your NFT
            </h3>
            <p className="bg-gradient-to-b from-uniqueFade-light via-uniqueFade-mid to-uniqueFade-dark bg-clip-text pb-1 text-center font-gt-haptik text-heading-4-mobile text-transparent md:text-heading-3">
              {text}
              <span className="opacity-0">|</span>
            </p>
            <ViewDealsButton />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TypingEffect;
